import React from 'react';
import { theme } from '../../config/theme';

const Table = ({ 
  columns, 
  data, 
  onRowClick,
  emptyMessage = 'No data available',
  hoverable = true,
}) => {
  const tableStyles = {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.lg,
    overflow: 'hidden',
  };

  const theadStyles = {
    backgroundColor: theme.colors.gray[50],
    borderBottom: `2px solid ${theme.colors.gray[200]}`,
  };

  const thStyles = {
    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
    textAlign: 'left',
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.semibold,
    color: theme.colors.text.primary,
  };

  const tdStyles = {
    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
    borderBottom: `1px solid ${theme.colors.gray[200]}`,
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.text.primary,
  };

  const rowStyles = (clickable) => ({
    cursor: clickable ? 'pointer' : 'default',
    transition: theme.transitions.fast,
  });

  const emptyStyles = {
    padding: theme.spacing['2xl'],
    textAlign: 'center',
    color: theme.colors.text.secondary,
    fontSize: theme.typography.fontSize.sm,
  };

  if (!data || data.length === 0) {
    return (
      <div style={{ 
        ...tableStyles, 
        border: `1px solid ${theme.colors.gray[200]}` 
      }}>
        <div style={emptyStyles}>{emptyMessage}</div>
      </div>
    );
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={tableStyles}>
        <thead style={theadStyles}>
          <tr>
            {columns.map((column, index) => (
              <th 
                key={index} 
                style={{ 
                  ...thStyles, 
                  width: column.width,
                  textAlign: column.align || 'left',
                }}
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              onClick={() => onRowClick?.(row)}
              style={rowStyles(!!onRowClick)}
              onMouseEnter={(e) => {
                if (hoverable) {
                  e.currentTarget.style.backgroundColor = theme.colors.gray[50];
                }
              }}
              onMouseLeave={(e) => {
                if (hoverable) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }}
            >
              {columns.map((column, colIndex) => (
                <td 
                  key={colIndex} 
                  style={{ 
                    ...tdStyles,
                    textAlign: column.align || 'left',
                  }}
                >
                  {column.render ? column.render(row) : row[column.accessor]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;